import { chakra } from '@chakra-ui/react';
import styled from '@emotion/styled/macro';
import { BETabProps } from './BETabProps';

const TabWrap = chakra('div', {
  shouldForwardProp: (prop) =>
    !['isActive', 'id', 'isDropdownItem'].includes(prop),
  baseStyle: {
    display: 'flex',
    flexFlow: 'column',
  },
});

export const StyledTabWrap = styled(TabWrap)<Partial<BETabProps>>`
  ${(props) => {
    if (props.isActive && !props.isDropdownItem) {
      return `
        &:not(:disabled) {
          background-color: white;
          color: black;
          border-bottom: 4px solid #32C0A0;
        }
      `;
    }
  }}
`;

const Tab = chakra('a', {
  shouldForwardProp: (props) => !['isActive'].includes(props),
  baseStyle: {
    alignItems: 'center',
    background: 'none',
    border: 'none',
    boxSizing: 'border-box',
    fontWeight: 'unset',
    textAlign: 'unset',
    textDecoration: 'unset',
  },
});

export const StyledTab = styled(Tab)<Partial<BETabProps>>`
  display: flex;
  padding: 16px;
  white-space: nowrap;

  &:disabled,
  &[disabled] {
    color: #a8a8a8;
    pointer-events: none;
  }

  &:hover {
    cursor: pointer;
  }

  ${(props) => {
    const { isActive } = props;

    if (isActive) {
      return `
        &:not(:disabled) {
          font-weight: 600;
          &:hover {
            background-color: white;
          }
        }
      `;
    } else {
      return `
        font-weight: 500;
        &:not(:disabled):hover {
          background-color: white;
        }
      `;
    }
  }}
`;

export const StyledTabDropdown = styled.div`
  ${StyledTabWrap} {
    box-shadow: none !important;
  }
`;
